var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51191 19.5694C8.19741 19.2999 8.16099 18.8264 8.43056 18.5119L14.0122 12L8.43056 5.48808C8.16099 5.17359 8.19741 4.70011 8.51191 4.43054C8.8264 4.16098 9.29988 4.1974 9.56944 4.51189L15.5694 11.5119C15.8102 11.7928 15.8102 12.2072 15.5694 12.4881L9.56944 19.4881C9.29988 19.8026 8.8264 19.839 8.51191 19.5694Z",
    fill: "#F7F6FD",
    fillOpacity: 0.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.02be71587ada26a6651d096bfa4a6130.svg";
export { ForwardRef as ReactComponent };